import TitleBorderLeft from "../../../components/Text/TitleBorderLeft";
import BorderLeftBox from "../../../components/boxes/BorderLeftBox";

const stakeholdersPageDataAr = {
    header : {
        image : {
            name : "stakeholders.jpg",
            alt : "Listen to Stakeholders page wallpaper",
        },
    },
    mainTitle : "نصغي باهتمام لأصحـاب المصلحة",
    paragraphOne : "نؤمن في الأول بأهمية التواصل البناء المتبادل وتوطيد علاقات التعاون مع جميع أصحاب المصلحة الذين يمثلون أولوية لدينا. ومن خلال العمل جنباً إلى جنب مع أصحاب المصلحة، نضمن تقديم قيمة مشتركة مستدامة على المدى القصير والمتوسط والطويل. فنحن ندرك أن لكل صاحب مصلحة أهداف وتوقعات واهتمامات مختلفة. وفي هذا السياق، نبذل قصارى جهودنا لنلبي احتياجات كل مجموعة من أصحاب المصلحة ونستفيد من ملاحظاتهم وآرائهم لتعزيز استراتيجيتنا للممارسات البيئية والاجتماعية والحوكمة المؤسسية.",
    infoGraphicOne : {
        nameOne : "stakeholder-1-ar.svg",
        nameTwo : "stakeholder-2-ar.svg",
        alt : "نضع مصالح أصحاب المصلحة في صميم استراتيجيتنا",
    },
    tabs : {
        headers : [
            "العملاء",
            "الموظفون",
            "الجهات التنظيمية",
            "المجتمعات المحلية",
            "المساهمون والمستثمرون",
            "شركاء الأعمال",
            "الموردون ومقدمو الخدمات",
        ],
        data : [
            <>
                <BorderLeftBox 
                    title={"العملاء"}
                    subtitle={"بفضل قاعدة عملائنا المستدامة، نتمكن في بنك الأول من الاستمرار في تقديم خدماتنا على المدى الطويل، ونترك بصمتنا لدعم المملكة ورؤيتها للعام 2030. كما نقدم خدمات رائدة في السوق تدعم أهداف وطموحات عملائنا من خلال دراستنا لاحتياجات السوق، وهذا ما يمهد الطريق أمامنا لتوطيد علاقات مستدامة طويلة الأمد. كما نواصل إطلاق حملات التواصل مع الموظفين وورش التدريب لننشر ثقافة الأول التي تضع العميل في قائمة أولوياتنا."}
                />
                <h3 className="text-title-small-2">أولويات العميل</h3>
                <ul className="normal-list pl-2">
                    <li>تجربة العملاء</li>
                    <li>التحول الرقمي</li>
                    <li>تزويد منتجاتنا بمزايا تنافسية مالية وغير مالية</li>
                    <li>الحماية من الاحتيال</li>
                    <li>أسعار الفائدة</li>
                    <li>الودائع والمشتقات المالية المرتبطة بالممارسات البيئية والاجتماعية والحوكمة المؤسسية</li>
                    <li>وضع الفرص العالمية في متناول عملائنا</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <h4 className="aria-title">مقاييس علاقاتنا</h4>
                </div>
                <div className="area-white">
                    <p className="area-red-text">
                    مؤشر توصية العملاء
                    </p>
                </div>
                <table className="area-table area-border-bottom">
                    <tr>
                        <th>قطاع إدارة الثروات والمصرفية الشخصية:</th>
                        <td>الخدمات المصرفية للشركات والمؤسسات: </td>
                    </tr>
                    <tr>
                        <th>95</th>
                        <td>91</td>
                    </tr>
                    <tr>
                        <th>(المرتبة 1)</th>
                        <td>(المرتبة 1)</td>
                    </tr>
                </table>
                <div className="area-white area-border-top">
                    <p className="area-red-text">
                    مؤشر صحة العلامة التجارية
                    </p>
                </div>
                <table className="area-table">
                    <tr>
                        <th>قطاع إدارة الثروات والمصرفية الشخصية:</th>
                        <td>الخدمات المصرفية للشركات والمؤسسات: </td>
                    </tr>
                    <tr>
                        <th>77</th>
                        <td>68</td>
                    </tr>
                    <tr>
                        <th>(المرتبة 2)</th>
                        <td>(المرتبة 3)</td>
                    </tr>
                </table>
                <div className="area-gray">
                    <h4 className="aria-title">قنوات المشاركة</h4>
                    <ul className="area-text">
                        <li>برنامج صوت العميل</li>
                        <li>تطبيقات المعاملات المصرفية عبر الإنترنت والمعاملات المصرفية عبر الهاتف المحمول</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <p className="text-paragraph">نفخر بحصولنا على جائزة "أفضل بنك لتجربة العملاء في المملكة العربية السعودية" للعام 2022 والممنوحة من مجلة غلوبال براندز. ولا شك أن فوزنا هذا يعكس ما نبذله من جهودٍ لتحسين تجربة عملائنا. ويسرنا كذلك تحقيق ثاني أفضل معدل تناقص عملاء من بين جميع البنوك الكبرى في المملكة بنسبة 10% (من العملاء النشطين)، وفقاً للبيانات المنشورة بالاعتماد على السوق.</p>
                <p className="text-paragraph">ونسلط الضوء في هذا العام أيضاً على أتمتة عملياتنا بواسطة الروبوتات بهدف إدارة شكاوى العملاء على نحوٍ أكثر كفاءة. إضافةً إلى ذلك، قمنا بتنفيذ برنامج ابتكار تجربة العملاء من خلال الاستفادة من قدراتنا وبياناتنا الرقمية لتكوين نظرة شاملة عن تجربة العملاء لدى بنك الأول. ومن خلال تحسين عملياتنا، نسعى إلى تجاوز توقعات العملاء في كل نقطة اتصال تجمعنا بهم.</p>
                <p className="text-paragraph">وبالنظر إلى المستقبل، سنواصل تعزيز تجربة عملائنا من خلال زيادة نقاط التحقق من ملاحظات العملاء وتحديث الدراسات المرجعية لتجربة عملائنا وتحديد الفجوات في السوق والاستفادة منها، فضلاً عن توجيه ثقافتنا نحو منح العملاء تجارب إيجابية في كل تعاملاتهم مع البنك.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="الموظفون"
                    subtitle="يُساهم موظفونا بدور محوري في استحداث القيمة طويلة المدى لأصحاب المصلحة لدينا. ونعتبر موظفينا بمثابة استثمارٍ حقيقي، ونعكف على ترسيخ ثقافة شركتنا باعتبارها تُمثّل عنصرًا أساسيًا للنجاح. فجذب المواهب التي تواكب المتطلبات المستقبلية والاحتفاظ بها وتطويرها يُعد جزءًا أساسيًا من رؤيتنا، وهذا ما يسمح لنا أن نأتي بعالم من الفرص المالية لمملكة طموحة. كما نعمل على رعاية المواهب السعودية ودعم المرأة وتمكين جيل المستقبل كجزء من هويتنا، ونعتبر موظفينا بمثابة ميزة تنافسية في السوق تتيح لنا فرصة خدمة عملائنا بشكل أفضل. ونؤكد على أهمية التطوير المستمر لجميع موظفينا في مجالات القيادة والتواصل وتجربة العملاء."
                />
                <h3 className="text-title-small-2">أولويات الموظفين</h3>
                <ul className="normal-list pl-2">
                    <li>بيئة عمل إيجابية داعمة</li>
                    <li>تحقيق التوازن بين العمل والحياة الشخصية</li>
                    <li>المكافآت والمزايا العادلة</li>
                    <li>التدريب والتطوير</li>
                    <li>الشفافية بين الإدارة والموظفين</li>
                    <li>توفير الفرص للمواطنين السعوديين</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">مقاييس علاقاتنا</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p className="">درجة المشاركة السنوية للموظفين: 73%</p>
                </div>
                <div className="area-gray">
                    <p className="area-title">قنوات المشاركة</p>
                    <ul className="area-list">
                        <li>اجتماعات ونقاشات غير رسمية مع فريق الإدارة</li>
                        <li>نقاشات قيادية مفتوحة حول مواضيع محددة</li>
                        <li>تسريع خطى برنامج تطوير المهارات القيادية لصغار المديرين</li>
                        <li>شواغل الاستراتيجية</li>
                        <li>فعاليات فريق العمل</li>
                        <li>فعاليات التكريم مثل جوائز الخدمة</li>
                        <li>أيام الفعاليات الدولية</li>
                        <li>فعاليات الممارسات البيئية والاجتماعية والحوكمة المؤسسية، بما فيها مبادرات التشجير</li>
                        <li>الاستطلاع السنوي لآراء الموظفين</li>
                        <li>برنامج الأول لتوظيف الخريجين</li>
                        <li>منصات التعلم لينكد إن وكورسيرا</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <p className="text-paragraph">أجرينا في بنك الأول الاستطلاع السنوي لآراء موظفينا في سبتمبر 2022، بمشاركة 99% من الموظفين. وكشفت نتائج الاستطلاع عن رؤى قيمة حول مدى إدراك موظفينا لاستراتيجية البنك في العام 2025. كما سلط الاستطلاع الضوء على مشاركة الموظفين ومستويات التزامهم في دعم استراتيجية البنك. ويسرنا تحقيق نسبة 73% من نقاط مشاركة الموظفين، وهي زيادة كبيرة عن نسبة 58% في عام 2021. كما نأخذ تعليقات الموظفين وملاحظاتهم على محمل الجد بهدف تحسين مشاركة الموظفين واعتمادها كوسيلة لضمان تحقيق النجاح المستقبلي سواء للبنك أو لموظفيه.</p>
                <p className="text-paragraph">وواصلنا خلال العام 2022 تنفيذ برنامج جوائز برافو ضمن الفروع المؤهلة وموظفي المبيعات. ويساهم هذا البرنامج في نشر ثقافة مؤسسية إيجابية وتعزيزها من خلال تقديم جوائز مالية وغير مالية للموظفين الذين يقطعون شوطًا إضافيًا في سبيل خدمة العملاء وبعضهم بعضًا ومصالح البنك.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="الجهات التنظيمية"
                    subtitle='تتضمن السلطات التنظيمية وزارة التجارة والبنك المركزي السعودي وهيئة السوق المالية وهيئة الزكاة والضريبة والجمارك. ونلتزم باتباع أعلى مستويات الحوكمة ونجري مراجعات منتظمة داخل البنك لتقييم وضمان الامتثال لكافة المتطلبات التنظيمية الصادرة عن وزارة التجارة والبنك المركزي السعودي "ساما" وهيئة السوق المالية. كما نسعى إلى مواكبة التغييرات الطارئة على صعيد البيئة التنظيمية وأفضل الممارسات المحلية والدولية. ولا تتوقف علاقتنا مع الجهات التنظيمية عند حدود الالتزام، بل نعتبرها شريكةً لنا في تحقيق أهداف القطاع المالي في المملكة بما يتماشى مع رؤية السعودية 2030.'
                />
                <h3 className="text-title-small-2">الأولويات التنظيمية</h3>
                <ul className="normal-list pl-2">
                    <li>دعم قطاع المنشآت المتناهية الصغر والصغيرة والمتوسطة والصناعات الأخرى ذات الأولوية لتحقيق رؤية 2030</li>
                    <li>امتثال الأول للمتطلبات التنظيمية</li>
                    <li>التنويع الاقتصادي</li>
                    <li>تعزيز الدور الاقتصادي الذي تلعبه المملكة العربية السعودية في دول مجلس التعاون الخليجي</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">مقاييس علاقاتنا</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p>نساهم في بنك الأول بتقديم الاستشارات، كلما لزم الأمر، ونسعى بشكل استباقي وشفاف للحصول على مدخلات أصحاب المصلحة التنظيميين في الأمور التي تقع ضمن نطاق اختصاصاتهم. إضافةً لذلك، يعقد الأول اجتماعات مع الأعضاء التنظيميين بهدف تمتين علاقاته معهم ومناقشة المخاوف الكامنة لدى المؤسسات المماثلة واستعراض الحلول الممكنة لها.</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">قنوات المشاركة</h4>
                    <ul className="area-list">
                        <li>الردود على طلبات المدخلات</li>
                        <li>عقد الاجتماعات الشخصية ومكالمات الفيديو الجماعية</li>
                        <li>مراقبة قنوات الاتصال الرسمية</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <p className="text-paragraph">يعتزم توني كريبس، الرئيس التنفيذي لبنك الأول، دعم منظومة القطاعي المصرفي في جميع مناطق المملكة العربية السعودية والمساهمة في تطوير سياسات ولوائح الممارسات البيئية والاجتماعية والحوكمة المؤسسية الفعالة بما يتماشى مع رؤية السعودية 2030. وبفضل ما اكتسبناه من تجربة دولية من خلال شراكتنا مع مجموعة إتش إس بي سي، تكونت لدينا رؤى فريدة حول أفضل الممارسات العالمية، والتي ستتيح لنا تزويد السوق المحلي بفرصة اكتساب الخبرات وتنفيذ الممارسات المناسبة في المملكة. وباتباع هذا النهج، تتاح لبنك الأول وغيره من المؤسسات المالية إمكانية الاستفادة من تجارب المؤسسات التابعة لسلطات تنظيمية أخرى.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="المجتمعات المحلية"
                    subtitle="تحتل مجتمعاتنا المحلية عمومًا ومواطنينا السعوديين على وجه الخصوص أهمية استثنائية بالنسبة لنا. وبصفتنا لاعبًا رائدًا في القطاع المالي السعودي، تقع على عاتقنا مسؤولية تعزيز رفاهية المجتمعات التي نعمل فيها والمساهمة في بناء مجتمع صحي ومزدهر. كما تسمح لنا شراكاتنا طويلة الأمد مع الهيئات الحكومية والجمعيات الخيرية بالمشاركة في مجموعة من البرامج الاجتماعية المصممة خصيصاً لدعم مجتمعاتنا على المديين القصير والمتوسط."
                />
                <h3 className="text-title-small-2">أولوياتنا المجتمعية</h3>
                <ul className="normal-list pl-2">
                    <li>دعم قطاع المنشآت المتناهية الصغر والصغيرة والمتوسطة</li>
                    <li>تمكين جيل الشباب</li>
                    <li>السعودة</li>
                    <li>الوعي المالي</li>
                    <li>مبادرات الاستثمار الخيرية والاجتماعية</li>
                    <li>فتح أفق الاستثمار والسياحة داخل المملكة</li>
                    <li>تطوير البنى التحتية</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">مقاييس علاقاتنا</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p>نعتمد على التقارير والملاحظات الواردة من شركائنا المساهمين في تنفيذ البرامج المجتمعية. ونتلقى عمومًا التقارير على أساس شهري، وتصلنا في بعض الأحيان التقارير بمجرد انتهاء البرنامج ذي الصلة.</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">قنوات المشاركة والشركاء في المسؤولية الاجتماعية</h4>
                    <ul className="area-list">
                        <li>برنامج "منشآت" لتطوير قطاع المنشآت متناهية الصغر والصغيرة والمتوسطة</li>
                        <li>برنامج مسرّعة "تقدَّم" للمنشآت المتناهية الصغر والصغيرة والمتوسطة</li>
                        <li>برنامج "ريالي" للوعي المالي</li>
                        <li>أكاديمية "الأول" الرقمية للشباب</li>
                        <li>مبادرة بنك الطعام السعودي لدعم الأسر المحتاجة</li>
                        <li>دعم الأطفال من ذوي الاحتياجات الخاصة وأولياء أمورهم</li>
                        <li>برامج المركز الوطني للمسؤولية والدراسات لتعزيز الوعي المالي</li>
                        <li>برامج جمعية النهضة لدعم المرأة</li>
                        <li>جمعية سند الخيرية لدعم الأطفال المرضى بالسرطان</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <p className="text-paragraph">نتطلع في بنك الأول إلى توفير مزايا طويلة الأمد للمجتمعات. وهذا يمكننا من ترك بصمة هادفة بطريقة مستدامة. وبحلول العام 2022، نجحنا في تحسين سياسة المسؤولية الاجتماعية المعتمدة لدينا بهدف التركيز على دعم المنشآت المتناهية الصغر والصغيرة والمتوسطة والتعليم والبيئة.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="المساهمون والمستثمرون"
                    subtitle="يزودنا مجتمع المستثمرين برأس المال اللازم لتنفيذ استراتيجيتنا طويلة الأمد. فهو يشكل جزءً من مجموعة واسعة من أصحاب المصلحة تضم المساهمين الحاليين والمستثمرين المحتملين ومحللي أبحاث حقوق الملكية المصرفية المحلية والعالمية والخبراء الاقتصاديين والمحللين من مختلف القطاعات والتخصصات. وترتكز استراتيجية علاقات المستثمرين في بنك الأول على توطيد العلاقات، وتهدف إلى بناء علاقات مستدامة طويلة الأمد مع مجموعات مستثمرينا، وبالتالي تشجع الحوار المتبادل عبر مجموعة متنوعة من الوسائط. كما يهدف برنامج علاقات المستثمرين لدينا إلى تزويد مجتمع المستثمرين برؤى وأفكار قيِّمة حول استراتيجية البنك وأدائه. ويتيح هذا الحوار المتبادل أيضاً للبنك الحصول على رؤى قيّمة عن حالة السوق."
                />
                
                <div className="space-50"></div>
                <div className="area-gray">
                    <div className="area-flex">
                        <div className="area-col">
                            <h4 className="area-title">أولويات المساهمين والمستثمرين</h4>
                            <ul className="area-list">
                                <li>تحقيق نمو مستدام طويل الأمد لاستثماراتهم</li>
                                <li>فهم الاستراتيجية طويلة الأمد والأداء المالي لبنك الأول</li>
                                <li>تكوين فهم حول استراتيجية بنك الأول والتزاماته فيما يتعلق بالممارسات البيئية والاجتماعية والحوكمة المؤسسية، وكيف تُكمل الاستراتيجية الشاملة للبنك.</li>
                            </ul>
                        </div>
                        <div className="area-col">
                            <h4 className="area-title">قنوات المشاركة</h4>
                            <ul className="area-list">
                                <li>تقارير الأرباح ربع السنوية</li>
                                <li>مؤتمرات المستثمرين المحلية والإقليمية والدولية</li>
                                <li>الاجتماعات الدورية مع مجتمع المحللين</li>
                                <li>الاجتماعات الدورية مع المستثمرين محلياً في مكاتبنا، وكذلك الاجتماعات الافتراضية</li>
                                <li>الاجتماع السنوي للجمعية العامة</li>
                                <li>تحديثات مدعومة بالوثائق، بما فيها العروض التقديمية المنتظمة وإفصاحات الأرباح والسجلات التي يمكن الوصول إليها عبر موقعنا الإلكتروني</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <ul className="normal-list pl-2">
                  <li>حضور كافة المؤتمرات الكبرى التي يعقدها المستثمرون في المملكة، بما فيها جميع المؤتمرات التي تنظمها السوق المالية السعودية</li>
                  <li>عقد أكثر من 100 اجتماع مع المستثمرين والمساهمين الأفراد خلال عام 2022 عبر تنظيم مؤتمرات للمستثمرين وزيارات مكاتبنا، إضافةً إلى التواصل مع ما يزيد على 170 مستثمرًا ومحللًا</li>
                  <li>تسجيل زيادة بنسبة 18% في القيمة السوقية خلال العام 2022، وجعلتنا في صدارة مؤسسات القطاع المصرفي في المملكة</li>
                </ul>
            </>,
            <>
                <BorderLeftBox 
                    title="شركاء الأعمال "
                    subtitle="شركاء أعمالنا هم أساس الثقة التي نبنيها مع عملائنا. نتشارك معهم جودتنا العالية وسمعتنا الطيبة."
                />
                <h3 className="text-title-small-2">شواغل شركاء الأعمال </h3>
                <ul className="normal-list pl-2">
                    <li>الأداء المالي لبنك الأول وصحة العلامة التجارية</li>
                    <li>انسجامنا مع رؤية المملكة 2030</li>
                    <li>تحويل العمليات وتبسيطها</li>
                    <li>سمعة بنك الأول في السوق</li>
                    <li>تعزيز التعاون</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">مقاييس علاقاتنا</p>
                </div>
                <div className="area-white area-border-bottom-none">
                    <p>الاتفاقيات والاجتماعات المستمرة</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">قنوات المشاركة </h4>
                    <ul className="area-list">
                        <li>مذكرات التفاهم والعقود</li>
                        <li>الاجتماعات والمشاركات الشخصية</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <p className="text-paragraph">في العام 2022، وقعنا في بنك الأول اتفاقية مشتركة مع مؤسسة مروج، الذراع التنفيذي للمركز الوطني لتنمية الغطاء النباتي ومكافحة التصحر، انطلاقًا من رغبتنا في المساهمة في مبادرة السعودية الخضراء من خلال زراعة مليون شجرة في جميع مناطق المملكة بحلول العام 2030.</p>
            </>,
            <>
                <BorderLeftBox 
                    title="الموردون ومقدمو الخدمات"
                    subtitle="نطرح أفضل المنتجات والخدمات في السوق بفضل تعاقدنا مع نخبة من أفضل الموردين ومقدمي الخدمات النوعيين. ونتطلع إلى إشراك أفضل الشركاء لتحقيق مصالحنا المشتركة بما ينسجم مع النهج الذي نتبعه في التعامل مع جميع أصحاب المصلحة."
                />
                <h3 className="text-title-small-2">أولويات الموردين ومقدمي الخدمات</h3>
                <ul className="normal-list pl-2">
                    <li>مدفوعات الفواتير في الوقت المحدد</li>
                    <li>التدفقات النقدية</li>
                    <li>إجراءات اختيار الموردين</li>
                </ul>
                <div className="space-50"></div>
                <div className="area-gray">
                    <p className="area-title">مقاييس علاقاتنا</p>
                </div>
                <div className="area-white">
                    <p>جودة المنتجات والخدمات</p>
                </div>
                <div className="area-white">
                    <p>التسليم</p>
                </div>
                <div className="area-white area-border-bottom-none ">
                    <p>التكلفة</p>
                </div>
                <div className="area-gray">
                    <h4 className="area-title">قنوات المشاركة</h4>
                    <ul className="area-list">
                        <li>الاجتماعات والمشاركات الشخصية</li>
                        <li>التقييمات السنوية للموردين</li>
                    </ul>
                </div>
                <div className="space-50"></div>
                <TitleBorderLeft>استعراض نتائج العام 2022</TitleBorderLeft>
                <p className="text-paragraph">أضفنا في بنك الأول خلال العام 2022 مدونة قواعد السلوك إلى متطلبات تسجيل الموردين لدينا بهدف ضمان الامتثال لمعايير الحوكمة البيئية والاجتماعية والمؤسسية والاقتصاد والصحة والسلامة والأخلاقيات. كما أجرينا مراجعة للعقوبات وتقييمًا للمخاطر المتأصلة والمخاطر المتبقية لبائعينا للتأكد من التزامهم بمعايير حوكمة المخاطر ذاتها المتبعة في عملياتنا. ونجري اليوم تقييمًا سنويًا للموردين، مع إعادة النظر في المخاطر قبل تجديد العقود.</p>
                <p className="text-paragraph">وفي مطلع هذا العام، حصل الأول على جائزة برنامج التميز في المشتريات من معهد تشارترد للشراء والتوريد لاستيفائه بنجاح المعايير الشاملة لتطوير أنشطة الشراء والتوريد وتحقيق التميز في إدارة الإجراءات على المستوى القياسي. وتُعد هذه الجائزة من أرقى الجوائز العالمية، وتُمنح للمؤسسات والشركات التي تحقق أعلى مستويات التميز في أنشطة المشتريات وسلاسل التوريد، وذلك بعد إجراء تقييم مستقل وشامل مصمم خصيصاً لوظائف الشراء.</p>
                <div className="space-50"></div>
                <img 
                    src={require('../../../assets/images/sections/stakeholder-1.jpg')} 
                    alt="Supplier and service provider priorities wallpaper" 
                    className="area-image"
                />
            </>,
        ],
    }
};

export default stakeholdersPageDataAr;